import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const futureLinearHistoryItemSchema = z.object({
  /** Symbol name */
  symbol: z.string(),
  /** Order ID */
  orderId: z.string(),
  /** Buy, Sell */
  side: z.string(),
  /** Order quantity */
  qty: decimalSchema,
  /** Order price */
  orderPrice: decimalSchema,
  /** Order type. Market, Limit */
  orderType: z.string(),
  /** Exec type (e.g., Trade, BustTrade, SessionSettlePnL, Settle, MovePosition) */
  execType: z.string(),
  /** Closed size */
  closedSize: decimalSchema,
  /** Cumulated position value */
  cumEntryValue: decimalSchema,
  /** Average entry price */
  avgEntryPrice: decimalSchema,
  /** Cumulated exit position value */
  cumExitValue: decimalSchema,
  /** Average exit price */
  avgExitPrice: decimalSchema,
  /** Closed PnL */
  closedPnl: decimalSchema,
  /** The number of fills in a single order */
  fillCount: decimalSchema,
  /** Leverage */
  leverage: decimalSchema,
  /** Open position trading fee */
  openFee: decimalSchema,
  /** Close position trading fee */
  closeFee: decimalSchema,
  /** The created time (ms) */
  createdTime: z.string(),
  /** The updated time (ms) */
  updatedTime: z.string(),
})

export const responseSchema = z.object({
  /** レスポンスコード。0 は成功 */
  retCode: z.number(),
  /** レスポンスメッセージ */
  retMsg: z.string(),
  result: z.object({
    /** Product type */
    category: z.string(),
    /** Object list */
    list: z.array(futureLinearHistoryItemSchema),
    /** Refer to the cursor request parameter */
    nextPageCursor: z.string().nullable(),
  }),
})
